// Visible Suspense fallback used in place of empty `<></>` fallbacks.
//
// Why: the navbar (Header) is rendered as a sibling of <Outlet/> in Layout, while
// routed pages render inside <Outlet/> under a route-level <Suspense>. When a page
// (or a lazy chunk it renders) suspends during a non-transition update, React swaps
// the live content for the nearest Suspense fallback. With an empty fallback that
// reads as a white screen below the navbar. Showing the app-wide loader instead means
// any suspension surfaces as a spinner that self-resolves once the chunk loads.
//
// Reuses the global `.loader-wrapper`/`.loader` styles (see App.css) for consistency
// with the loaders already used across the app.
export default function RouteFallback() {
  return (
    <div className='loader-wrapper'>
      <div className='loader'>
        <img src='assets/images/loader.gif' alt='Loading' />
      </div>
    </div>
  )
}
